import React, { useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import cn from 'classnames';
import styles from './Accordion.module.scss';

export interface OwnProps {
  title: string;
  expanded?: boolean;
  children: React.ReactNode;
  titleClassName?: string;
  theme?: string;
}

const Accordion = ({ title, expanded, children, titleClassName, theme }: OwnProps) => {
  const [isExpanded, expand] = useState(!!expanded);

  const toggleAccordeon = () => {
    expand(!isExpanded);
  };

  return (
    <div className={cn(styles.accordion, styles[`theme-${theme}`])} aria-expanded={isExpanded}>
      <div className={cn(styles.accordionTitle, titleClassName)} onClick={toggleAccordeon}>
        <span>{title}</span>
        <BsChevronDown className={cn(styles.toggle)} />
      </div>
      <div className={styles.accordionContent}>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
